module.exports = __webpack_public_path__ + "img/Group3.585a1619.png";